import React, { useMemo } from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';
import isObject from 'lodash/isObject';
import CdnImage from '../CdnImage';
import store from '../../shared/Store';
import { replaceUriValues } from '../../utils/stringUtils';

const injectStrategies = {
  user: () => store.user,
};

function ImageBlock(props) {
  const { image, title, style, inject, ...rest } = props;
  const injectedValues = useMemo(() => inject?.map((strategy) => injectStrategies[strategy]?.()), [
    inject,
  ]);

  const computedImage = useMemo(() => {
    if (!injectedValues?.length) return image;
    const globalInjectedValue = Object.assign({}, ...injectedValues);

    let res = isObject(image) ? { ...image } : image;
    if (isObject(res)) {
      res.uri = replaceUriValues(res.uri, globalInjectedValue);
    } else {
      res = replaceUriValues(res, globalInjectedValue);
    }

    return res;
  }, [image, injectedValues]);

  return (
    <CdnImage
      className={cx('block--image', rest._id)}
      as="img"
      src={computedImage}
      style={{ maxWidth: '100%', ...style }}
      alt={title || 'img-block'}
      maxWidth={1920}
      {...rest}
    />
  );
}

ImageBlock.defaultProps = {
  image: undefined,
  style: {},
  inject: [],
  title: undefined,
};

ImageBlock.propTypes = {
  image: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  style: PropTypes.object,
  inject: PropTypes.arrayOf(PropTypes.string),
  title: PropTypes.string,
};

export default ImageBlock;
